export default __webpack_public_path__ + "static/media/RAIDER 125_5.9a061878.webp";